import React from "react";
import { FiClock, FiLogIn } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./session-expired.css";

export default function SessionExpired() {
  const navigate = useNavigate();

  return (
    <main className="session-expired-page">
      <img className="session-expired-logo" src={logo} alt="Hallef Technologies" />
      <section className="session-expired-card" aria-labelledby="session-expired-title">
        <div className="session-expired-icon"><FiClock aria-hidden="true" /></div>
        <p className="session-expired-eyebrow">YOUR SECURITY MATTERS</p>
        <h1 id="session-expired-title">Your session has expired</h1>
        <p className="session-expired-description">
          Your session is no longer valid. Sign in again to continue.
        </p>
        <button className="session-expired-login" type="button" onClick={() => navigate("/login")}>
          <FiLogIn aria-hidden="true" style={{ color: "white" }}
          /> Sign in again
        </button>
      </section>
      <p className="session-expired-footer">Hallef Technologies <span aria-hidden="true">&middot;</span> Secure access</p>
    </main>
  );
}
